import config from '../common/config';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { fromJS } from 'immutable';
import { connect } from 'react-redux';
import { Grid, Cell } from 'react-flexr';
import { palm } from 'react-flexr';


import { getOffers, getMbb, isLoaded } from '../redux/modules/broadband';
import { getCoverage } from '../redux/modules/coverage';
import { getCoveragByProvider } from '../redux/modules/provider';
import ProductCategory from '../common/product-category';
import { SearchPanel, SearchGroup, Slider } from '../common/search';
import Loader from '../common/loader';
import TagFilter from '../common/tagFilter';
import Showcase from '../common/showcase';
import AutoCompleteDAWA from '../common/autocomplete-dawa';

import * as date from '../utils/date-fns';
import { serialiseMbb } from '../mbb/offers';

const implementedProviders = [
  'Norlys',
// 'Telenor',
  'Bolignet',
  'Bornfiber',
  'Ewii',
// 'Fastspeed', // DISABLED 16. January 2025 - DUE TO DISCONTINUED AFFILIATION PROGRAM
// 'Jetnet', // DISABLED 16. January 2025 - DUE TO DISCONTINUED AFFILIATION PROGRAM
  'Kviknet',
  'Stofa',
  'Telia',
  'Waoo',
  'Hiper',
  'Altibox'
];

const ADSL = 'ADSL';
const CABLE_TV = 'KabelTV';
const FIBER = 'Fiber';

function serializeConnection(value) {
  switch(value) {
      case 'xDSL':
      case 'DSL':
      case 'Telefonstik':
          return 'landline';
      case 'FIBER':
      case 'Fiber':
          return 'fiber';
      case 'COAX':
      case 'Coax':
      case 'Kabel-Tv':
      case 'KabelTV':
          return 'cable';
      case 'MOBILE':
          return 'mobile';
      default:
          return value;
  }
}

const FREE_CREATION = 'Gratis oprettelse';
const STATIC_IP_POSSIBLE = 'Med statisk IP';
const NO_REQUIREMENTS = 'Ingen krav (tv-pakke etc.)';
const INCLUDES_WIRELESS_ROUTER = 'Med trådløs router';

const DEFAULT_DOWNLOAD = 25;
const UNLIMITED_DOWNLOAD = 1000;
const ALL_DOWNLOAD = 0;

const DEFAULT_UPLOAD = 10;
const UNLIMITED_UPLOAD = 1000;
const ALL_UPLOAD = 0;

const ALL_MSG = '';

class Offers extends ProductCategory {
  static fetchData({ getState, dispatch }) {
    if (!isLoaded({ getState })) {
      return dispatch(getOffers());
    }
  }

  static defaultProps = {
    category: 'broadband'
  };

  constructor(props) {
    super(props);

    this.state = this.mapPropsToState(props, {
      offerType: 'bredbånd',
      ...this.state,
      location: {},
      locationLoading: false,
      addressReset: false,
      sort: this.createSort({ weight: -1, 'price.monthly': 1 }),
      coverage_private: true,
      fetchedProviders: [],
      // staticOffers: [],
      staticOffersSeparator: '5G Internet', 
      latestAddressId: null,
      defaultFilters: { // FOR FILTERS_USED EPI
        download: null,
        upload: null,
        signalADSL: true,
        signalCable: true,
        signalFiber: true,
        freeCreation: false,
        staticIp: false,
        noRequirements: false,
        wirelessRouter: false,
        coverages: [],
        providers: [],
        tags: []
      },
      filters: {
        download: null,
        upload: null,
        signalADSL: true,
        signalCable: true,
        signalFiber: true,
        freeCreation: false,
        staticIp: false,
        noRequirements: false,
        wirelessRouter: false,
        tags: [],
        providers: [],
        coverages: [],
        ...(this.state.filters || {})
      }
    });

    // this.state = {
    //   offers: this.serialise(props.offers || List()),
    //   filter: this.createFilter({ netSpeed: 10, filters }),
    //   // for some reason, weight is sorted by 10, 9, 8...(highest first, descending) while contractPeriod is 8, 9, 10... (smallest first, ascending)
    //   sort: this.createSort({ 'price.contractPeriod': 1 }),
    //   netSpeed: 10,
    //   filters
    // };
  }

  resetFilter() {
    const filters = {
      ...(this.state.filters || {}),
      download: null,
      upload: null,
      signalADSL: true,
      signalCable: true,
      signalFiber: true,
      freeCreation: false,
      staticIp: false,
      noRequirements: false,
      wirelessRouter: false,
      coverages: [],
      providers: [],
      tags: []
    };
    
    this.setState({
      addressReset: !this.state.addressReset,
      location: {},
      addressId: null,
      staticOffers: [],
      filters,
      filtersUsed: false,
      filter: this.createFilter(filters)
    });
  }

  createFilter(filters) {
    this.updateFiltersUsed(filters); // FOR FILTERS_USED EPI

    // WAOO REQUIRES ADDRESS SEARCH
    // const addressId = this.state.addressId;
    
    return offers => {
      return offers.filter(offer => {
        const tags = Array.from(offer.getIn(['_raw', 'tags']));
        const manualTags = offer.getIn(['_raw', 'manualTags']) ? Array.from(offer.getIn(['_raw', 'manualTags'])) : [];
        const mergedTags = tags.reduce((acc, tag) => {
          if(!acc.includes(tag)) {
            acc.push(tag);
          }
          return acc;
        }, manualTags || []).filter(Boolean);

        const lowerCaseTags = mergedTags.map(i => i.toLowerCase());
        const services = Array.from(offer.getIn(['_raw', 'services']));
        const lowerCaseServices = services.map(i => i.toLowerCase());
        
        const connection = offer.getIn(['_raw', 'connection']);
        const signal = offer.getIn(['_raw', 'signal']);
        const lowerCaseProvider = offer.get('provider').toLowerCase().trim().replace('-', ' ');

        if(lowerCaseProvider === 'waoo') { // REMOVE WAOO RESULTS
          return false;
        }

        const filteredTags = filters.tags;

        for (let idx = 0; idx < filteredTags.length; idx++) {
          const tag = filteredTags[idx];
          if (
            !lowerCaseServices.includes(tag) &&
            !lowerCaseTags.includes(tag) && 
            !mergedTags.includes(tag) &&
            !services.includes(tag) &&
            tag.toLowerCase() !== lowerCaseProvider &&
            tag.toLowerCase() !== connection &&
            tag.toLowerCase() !== signal
          ) {
            return false;
          }
        }

        if (filters.download !== null) {
          if (
            filters.download !== ALL_DOWNLOAD &&
            offer.getIn(['_raw', 'speed', 'download']) < filters.download
          ) {
            return false;
          }
        }

        if (filters.upload !== null) {
          if (
            filters.upload !== ALL_UPLOAD &&
            offer.getIn(['_raw', 'speed', 'upload']) < filters.upload
          ) {
            return false;
          }
        }

        if (
          !(
            (connection === 'cable' &&
              filters.signalCable &&
              signal !== 'fiber') ||
            (filters.signalCable && filters.signalADSL && signal !== 'fiber') ||
            (filters.signalCable &&
              filters.signalFiber &&
              signal === 'fiber') ||
            !filters.signalCable
          )
        ) {
          return false;
        }
        if (
          !(
            (connection === 'landline' &&
              filters.signalADSL &&
              signal !== 'fiber') ||
            (filters.signalCable && filters.signalADSL && signal !== 'fiber') ||
            (filters.signalADSL && filters.signalFiber && signal === 'fiber') ||
            !filters.signalADSL
          )
        ) {
          return false;
        }

        if (
          !(
            (signal === 'fiber' && filters.signalFiber) ||
            (filters.signalCable &&
              filters.signalFiber &&
              connection === 'cable' &&
              filters.signalCable &&
              signal !== 'fiber') ||
            (filters.signalADSL &&
              filters.signalFiber &&
              connection === 'landline' &&
              filters.signalADSL &&
              signal !== 'fiber') ||
            !filters.signalFiber
          )
        ) {
          return false;
        }

        if (
          !(
            (offer.getIn(['_raw', 'fees', 'startup']) === 0 &&
              filters.freeCreation === true) ||
            filters.freeCreation === false
          )
        ) {
          return false;
        }

        if (
          !(
            (mergedTags.includes('Statisk IP') &&
              filters.staticIp) ||
            filters.staticIp === false
          )
        ) {
          return false;
        }

        if (
          !(
            (mergedTags.includes('Trådløs Router') &&
              filters.wirelessRouter) ||
            filters.wirelessRouter === false
          )
        ) {
          return false;
        }

        if (
          !(
            ((offer.getIn(['_raw', 'demands']) === null ||
              offer.getIn(['_raw', 'demands']) === 'No') &&
              filters.noRequirements === true) ||
            filters.noRequirements === false
          )
        ) {
          return false;
        }

        // WAOO REQUIRES ADDRESS SEARCH
        // if(offer.get('provider') === 'Waoo' && !addressId) {
        //   return false;
        // }

        if(filters.coverages && filters.coverages.length) {
          const coverages = filters.coverages.find((v) => serializeConnection(v.connection) === connection);
          if(!coverages) {
            return false;
          }

          const coverage = this.state.coverage_private ? coverages.private : coverages.business;
          if(Number(coverage.download) < offer.getIn(['_raw', 'speed', 'download'])) {
            return false;
          }
          if(Number(coverage.upload) < offer.getIn(['_raw', 'speed', 'upload'])) {
            return false;
          }
        }

        if(implementedProviders.includes(offer.get('provider')) && filters.providers && filters.providers.length) {
          const coverages = filters.providers.filter((v) => {
            if(v.owner) { 
              return v.provider === offer.get('provider') && v.owner === offer.get('owner');
              // return v.provider === offer.get('provider') || v.owner === offer.get('owner'); // WAOO SHOWS IF EITHER PROVIDER OR OWNER MATCHES
            }

            return v.provider === offer.get('provider');
          });

          if(coverages && coverages.length) {
            for (let idx = 0; idx < coverages.length; idx++) {
              const coverage = coverages[idx];
              const coverageConnection = serializeConnection(coverage.connection);

              if(coverageConnection === connection && Number(coverage.download) <= offer.getIn(['_raw', 'speed', 'download'])) {
                return true;
              }
              if(coverageConnection === connection &&  Number(coverage.upload) <= offer.getIn(['_raw', 'speed', 'upload'])) {
                return true;
              }
            }
          }

          return false;
        }

        return true;
      });
    };
  }

  // islandline(connection, signal, filters) {
  //   return connection === 'landline' && filters.signalADSL && signal !== 'fiber' || !filters.signalADSL;
  // }

  // isCable(connection, signal, filters) {
  //   return connection === 'cable' && filters.signalCable && signal !== 'fiber' || !filters.signalCable;
  // }

  // isFiber(signal, filters) {
  //   return signal === 'fiber' && filters.signalFiber || !filters.signalFiber;
  // }

  // pre-validate data, to ensure we only include valid offers
  // serialise(offers) {
  //   offers = offers.filter(o => {
  //     if (!o.get('expire')) {
  //       return true;
  //     }
  //     return new Date(o.get('expire')) >= new Date();
  //   });
  //
  //   return offers.map(offer => {
  //     const subOffers = offer.get('subOffers');
  //     if (subOffers && subOffers.size > 0) {
  //       const original = fromJS(offer.toJS());
  //       let notExpired = false;
  //
  //       offer = subOffers.reduce((acc, subOffer) => {
  //         if (new Date(subOffer.get('expire')) >= new Date()) {
  //           notExpired = true;
  //           return acc.mergeDeep(subOffer);
  //         }
  //         return acc;
  //       }, offer);
  //
  //       if (notExpired) {
  //         offer = offer.set('original', original);
  //       }
  //     }
  //
  //     return this.serialiseOffer(offer);
  //   });
  // }

  serialiseOffer(offer) {
    let remark = '';
    if (offer.get('period') == 6) {
      remark = `6 måneders binding, hvor mindsteprisen i perioden er ${offer.getIn(
        ['price', 'sixMonths']
      )} kr.`;
    } else {
      remark = `${offer.get('period')} ${
        offer.get('period') === 1 ? 'måneds' : 'måneders'
      } binding, hvor mindsteprisen i perioden er ${offer.getIn([
        'price',
        'contractPeriod'
      ])} kr. og prisen for 6 måneder er ${offer.getIn([
        'price',
        'sixMonths'
      ])} kr. *`;
    }
    
    const tags = offer.get('tags') ? offer.get('tags').toJS() : [];
    const manualTags = offer.get('manualTags') ? Array.from(offer.get('manualTags')) : [];
    const mergedTags = tags.reduce((acc, tag) => {
      if(!acc.includes(tag)) {
        acc.push(tag);
      }
      return acc;
    }, manualTags || []).filter(Boolean);

    const result = fromJS({
      id: offer.get('_id'),

      provider: offer.get('provider'),
      product: offer.get('product'),
      owner: offer.get('owner'),
      logo:
        offer.getIn(['image', 'hash']) &&
        `${config.images}${offer.getIn(['image', 'hash'])}`,
      link: `/redirect/${offer.get('uuid')}`,
      orderText: 'Bestil nu',

      tagline: offer.get('tagline'),
      expire: date.format(offer.get('expire'), 'D. MMM'),

      details: [
        {
          value: offer.getIn(['speed', 'download']),
          unit: 'Mbit/s',
          label: 'Download'
        },
        {
          value: offer.getIn(['speed', 'upload']),
          unit: 'Mbit/s',
          label: 'Upload'
        },
        {
          value: offer.getIn(['fees', 'startup']),
          unit: 'kr.',
          label: 'Oprettelse'
        }
        // {
        //   value: offer.get('period'),
        //   unit: 'mdr.',
        //   label: 'binding'
        // }, 
      ].filter(Boolean),

      priceSixMonth: offer.getIn(['price', 'sixMonths']) ? {
        value: offer.getIn(['price', 'discountSixMonths']) &&
        offer.getIn(['price', 'discountSixMonths']) < offer.getIn(['price', 'sixMonths'])
          ? offer.getIn(['price', 'discountSixMonths'])
          : offer.getIn(['price', 'sixMonths']),
        unit: 'kr.',
        label: 'pris 6 mdr.',
        old:
          offer.getIn(['price', 'discountSixMonths']) &&
          offer.getIn(['price', 'discountSixMonths']) < offer.getIn(['price', 'sixMonths'])
            ? offer.getIn(['price', 'sixMonths'])
            : null
      } : null,

      price: {
        value: offer.getIn(['price', 'discountMonthly']) &&
        offer.getIn(['price', 'discountMonthly']) < offer.getIn(['price', 'monthly'])
          ? offer.getIn(['price', 'discountMonthly'])
          : offer.getIn(['price', 'monthly']),
        unit: 'kr.',
        label: 'Pris pr. md.',
        old:
          offer.getIn(['price', 'discountMonthly']) &&
          offer.getIn(['price', 'discountMonthly']) < offer.getIn(['price', 'monthly'])
            ? offer.getIn(['price', 'monthly'])
            : null
      },

      usps: [offer.get('signal') === 'fiber' ? 'Fiber' : null]
        .concat(offer.get('services') ? offer.get('services').toJS() : [])
        .concat(mergedTags)
        .filter(Boolean),

      requirements: [this.csvToArray(offer.get('demands')) || null].filter(
        Boolean
      ),

      productDescription: offer.get('productDescription'),
      discountCode: offer.get('discountCode'),
      remarks: {
        headline: 'Omkostninger:',
        text: remark
      },
      remark: implementedProviders.includes(offer.get('provider')) ? null :  this.state.location && this.state.location.address ? {
        headline: 'Bemærk:',
        text: 'Produktet er ikke tjekket mod adressen'
      } : null,

      _raw: offer
    });

    return result;
  }

  csvToArray(csv) {
    if (csv) {
      return csv
        .trim()
        .split(',')
        .map(e => e.trim());
    }
    return null;
  }

  searchChanged(e) {
    const filters = this.state.filters;
    const v = e.target.value;

    if (v === ADSL) {
      filters.signalADSL = !filters.signalADSL;
    } else if (v === CABLE_TV) {
      filters.signalCable = !filters.signalCable;
    } else if (v === FIBER) {
      filters.signalFiber = !filters.signalFiber;
    } else if (v === FREE_CREATION) {
      filters.freeCreation = !filters.freeCreation;
    } else if (v === STATIC_IP_POSSIBLE) {
      filters.staticIp = !filters.staticIp;
    } else if (v === NO_REQUIREMENTS) {
      filters.noRequirements = !filters.noRequirements;
    } else if (v === INCLUDES_WIRELESS_ROUTER) {
      filters.wirelessRouter = !filters.wirelessRouter;
    }

    this.setState({ filters, filter: this.createFilter(filters) });
  }

  searchOnChange = ev => this.searchChanged(ev);

  sliderOnChange = ({ name, values }) => {
    const { filters } = this.state;
    const value = Number(values[0]);
    filters[name] = value;
    this.setState({
      filters,
      filter: this.createFilter(filters)
    });
  };

  createSearchDisplay(filters) {
    const arr = [];

    if (filters.download) {
      arr.push(filters.download + ' Mbit/s download');
    }
    if (filters.upload) {
      arr.push(filters.upload + ' Mbit/s upload');
    }

    return arr;
  }

  headlineDownload(download) {
    if (download) {
      const val = parseInt(download[0]);
      if (val == ALL_DOWNLOAD) {
        return 'Alle';
      }
      if (val === UNLIMITED_DOWNLOAD) {
        return `${UNLIMITED_DOWNLOAD}+ Mbit/s`;
      }
      return `${val} Mbit/s`;
    }
    return '';
  }

  headlineUpload(upload) {
    if (upload) {
      const val = parseInt(upload[0]);
      if (val == ALL_UPLOAD) {
        return 'Alle';
      }
      if (val === UNLIMITED_UPLOAD) {
        return `${UNLIMITED_UPLOAD}+ Mbit/s`;
      }
      return `${val} Mbit/s`;
    }
    return '';
  }

  handleLocationSelect(choosen, unit) {
    const { location, latestAddressId } = this.state;
    if (typeof choosen === 'string' && choosen === location.address) {
      return;
    }
    const choosenAddress = choosen.value.replace('https://api.dataforsyningen.dk/adresser/', '');
    this.setState({ locationLoading: true });
    this.props.getCoverage(choosen.id).then((res) => {
      if(res.payload.status === 'OK' && res.payload && res.payload.coverages && res.payload.coverages.length) {
        const filters = this.state.filters;
        filters.coverages = res.payload.coverages;

        if(choosen.id !== latestAddressId) {
          this.setState({ fetchedProviders: [] });
          if(filters.providers.length) {
            filters.providers = [];
          }
        }

        if(res.payload.providers && res.payload.providers.length) {
          filters.providers = res.payload.providers || [];
        }

        this.setState({ filters, filter: this.createFilter(filters), addressId: choosenAddress, latestAddressId: choosen.id });

        if(res.payload.cacheProviders) {
          const fetchedProviders = this.state.fetchedProviders;
          for (let index = 0; index < implementedProviders.length; index++) {
            const provider = implementedProviders[index];
            if(fetchedProviders.includes(provider) || provider === 'Waoo') {
              continue;
            }
            this.props.getCoveragByProvider(choosen.id, provider).then((res) => {
              if(res.payload.status === 'OK' && res.payload && res.payload.coverage && res.payload.coverage.length) {
                const filters = this.state.filters;
                filters.providers = filters.providers.concat(res.payload.coverage);
        
                this.setState({ filters, filter: this.createFilter(filters) });
              }
              
              const fetchedProviders = this.state.fetchedProviders || [];
              fetchedProviders.push(provider);
              this.setState({ fetchedProviders });
      
            });
          }
          
          this.setState({ filters, filter: this.createFilter(filters) });
        }
      }

      this.setState({ locationLoading: false });
    }).catch(err => {
      this.setState({ locationLoading: false });
    });

    this.props.getMbb().then((res) => {
      if(res.payload.offers) {
        const offers = fromJS(res.payload.offers).map(serialiseMbb);
        this.setState({ staticOffers: offers.filter((v) => ['5G'].includes(v.getIn(['_raw', 'network', 'internet']))) });
      }
    });
    this.setState({
      location: unit,
      locationError: null
    });
  }

  handleOnBlur() {
    const { location } = this.state;
    if (!location || !location.id) {
      this.setState({
        locationError: 'Du skal vælge en bestemt adresse fra listen. Hvis din adresse ikke var der, så kontakt os.' 
      });
    }else {
      this.setState({ 
        locationError: null
      });
    }
  }

  updateResults() {
    const filters = this.state.filters;
    this.setState({ filters, filter: this.createFilter(filters) });
  }

  render() {
    const { offers, filter, filters, showcases, location, locationError, locationLoading } = this.state;

    return (
      <Grid>
        <Cell size='3/12' portable='1/1' style={{ minWidth: 280 }}>
          <SearchPanel
            title={'Bredbånd'}
            results={offers}
            filter={filter}
            filterTexts={this.createSearchDisplay(filters)}
            displayAddress={true}
          >
            <SearchGroup alwaysDisplay={true}>
              <AutoCompleteDAWA
                  reset={this.state.addressReset}
                  headline={'Indtast adresse'}
                  placeholder={'fx Rådhuspladsen 1, 1550 København V'}
                  defaultValue={location && location.address}
                  onSelect={this.handleLocationSelect.bind(this)}
                  onBlur={this.handleOnBlur.bind(this)}
                  onFocus={() =>
                    this.setState({  location: null })
                  }
                  loader={!this.state.latestAddressId}
                />
                {locationError ? <p>{locationError}</p> : null}
                {/* {location && location.id ? <div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Radio
                    label={'Privat'}
                    name={'group1'}
                    type={'radio'}
                    onChange={(v) => this.setState({ coverage_private: v.target.value === 'on' })}
                    defaultChecked
                    id={'coverage_private'}
                  />
                  {'Privat'}
                  </div><div style={{ display: 'flex', alignItems: 'center'}}>
                  <Radio
                    label={'Erhverv'}
                    name='group1'
                    type={'radio'}
                    onChange={(v) => this.setState({ coverage_private: v.target.value !== 'on' })}
                    id={'coverage_business'}
                  />
                  {'Erhverv'}</div>
                </div> : null} */}
                {this.state.addressId ? <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: '20px' }}>
                    <a onClick={() => {
                      const filters = {
                        ...(this.state.filters || {}),
                        providers: [],
                        coverages: []
                      };
                      this.setState({ addressReset: !this.state.addressReset, addressId: null, location: {}, filters, filter: this.createFilter(filters) });
                    }} style={{ 
                      textWrap: 'wrap',
                      backgroundColor: 'rgba(255, 196, 20, 0.51)', // rgba(76, 175, 80, 0.10)
                      color: 'rgb(136, 96, 0)', // rgb(76, 175, 80)
                      border: '1px solid rgb(167, 132, 0)', // rgb(76, 175, 80)
                      display: 'inline-block',
                      fontSize: '1em',
                      padding: '.3em .7em .4em .4em',
                      marginTop: '0.5em',
                      marginRight: '0.5em',
                      fontWeight: 'normal',
                      maxWidth: '600px',
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                      ':before': {
                        marginRight: 5,
                        display: 'inline-block',
                        font: 'normal normal normal 14px/1 FontAwesome',
                        fontSize: 'inherit',
                        textRendering: 'auto',
                        WebkitFontSmoothing: 'antialiased',
                        MozOsxFontSmoothing: 'grayscale'
                      },
                      [palm]: {
                        fontSize: '.9em',
                        maxWidth: 'calc(100vw - 60px)'
                      }
                    }} className={'label'}>
                      <strong>{'Fjern adresse filter'}</strong>
                    </a>
                  </div> : null}
            </SearchGroup>
            <SearchGroup>
              <Slider
                name='download'
                connect='lower'
                disconnected={filters.download === null}
                headline={[
                  'Download',
                  val =>
                    filters.download === null
                      ? ALL_MSG
                      : this.headlineDownload(val)
                ]}
                units={['Alle | 10 Mbit/s', `${UNLIMITED_DOWNLOAD}+ Mbit/s`]}
                min={0}
                max={1000}
                range={{
                  min: [ALL_DOWNLOAD, 10],
                  '15%': [10, 40],
                  '30%': [50, 50],
                  '45%': [100, 100],
                  '60%': [300, 200],
                  '75%': [500, 500],
                  max: [UNLIMITED_DOWNLOAD]
                }}
                defaultStart={[filters.download || DEFAULT_DOWNLOAD]}
                onSlide={this.sliderOnChange}
              />
              <Slider
                name='upload'
                connect='lower'
                disconnected={filters.upload === null}
                headline={[
                  'Upload',
                  val =>
                    filters.upload === null ? ALL_MSG : this.headlineUpload(val)
                ]}
                units={['Alle | 10 Mbit/s', `${UNLIMITED_UPLOAD}+ Mbit/s`]}
                min={0}
                max={1000}
                range={{
                  min: [ALL_DOWNLOAD, 10],
                  '15%': [10, 40],
                  '30%': [50, 50],
                  '45%': [100, 100],
                  '60%': [300, 200],
                  '75%': [500, 500],
                  max: [UNLIMITED_DOWNLOAD]
                }}
                defaultStart={[filters.upload || DEFAULT_UPLOAD]}
                onSlide={this.sliderOnChange}
              />
            </SearchGroup>
            <TagFilter
              headline={'Tags'}
              feed={this.state.feed}
              offerType={this.state.offerType}
              items={offers}
              filters={filters}
              checkboxOnChange={this.tagsOnChange}
            />
          </SearchPanel>
        </Cell>
        <Cell>
          <Showcase list={showcases} orderText='Gå til udbyder' site_id={this.state.siteId} feed={this.state.feed} url={this.state.url} filters_used={this.state.filtersUsed} addressId={this.state.addressId} />
          {locationLoading ? <Loader /> : this.renderResults(
            '* Beløbet er beregnet, og der tages forbehold for evt. fejl i udregningen baseret på de oplyste beløb. Tjek derfor altid hvad udbyderen oplyser.',
            this.resetFilter.bind(this),
            this.updateResults.bind(this)
          )}
        </Cell>
      </Grid>
    );
  }
}

export default connect(({ broadband: { offers } }) => {
  return { offers };
}, { getCoverage, getCoveragByProvider, getMbb })(
  withRouter(Offers)
);
